import {
  SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE,
  SET_ADMIN_AUDIT_SEARCH_TEAMS,
  SET_ADMIN_AUDIT_ENTRY_HEADER, 
  SET_ADMIN_AUDIT_ENTRY_DETAILS
} from './constants';

export const initialState = { 
    searchEntryAuditValue: '',
    headerEntry:{
      tournamentId: null,
      tournamentName: '',
      eventName: '',
      teamName: '',
      entryId: null,
      tournamentTimeZone: '',
      entryNumber: '',
      captainName: '',
      coordinatorName: '',
      bowlDateTime: null,
      isCancelled: false
    },

    auditDetails: null,
    searchTeams: null,
    searchTeamsExceededResultLimit: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {

    case SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE:
      return {
        ...state,
        searchEntryAuditValue: payload
      }; 
 
    case SET_ADMIN_AUDIT_SEARCH_TEAMS:
      return {
        ...state,
        searchTeams: payload.list,
        searchTeamsExceededResultLimit: payload.exceededSearchLimit
      }; 

    case SET_ADMIN_AUDIT_ENTRY_HEADER:{
      let entry = initialState.headerEntry;

      if (payload.entry){
        entry = payload.entry;
      }

      return {
        ...state,
        headerEntry: entry 
      }; 
    }

    case SET_ADMIN_AUDIT_ENTRY_DETAILS:{
      let auditDetails = initialState.auditDetails;

      if (payload.list){
        auditDetails = payload.list;
      }

      return {
        ...state,
        auditDetails: auditDetails 
      }; 
    }
      
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/audit/entryAudit/reducer.js